<mat-card appearance="outlined" id="sample-center-login-card">
  <mat-card-content>
    <div id="sample-center-login-container">
      <mat-card-title id="sample-center-login-title">Sample Center Auto Login</mat-card-title>
      @if ((bannerStatus$ | async)) {
        <mat-toolbar
          id="sample-center-login-banner"
          color="{{ bannerColor$ | async }}"
          fxFlexFill
          >
          <span id="sample-center-login-banner-message">
            {{ bannerMessage$ | async }}
          </span>
        </mat-toolbar>
      }
      @if (showProgressSpinner) {
        <mat-progress-spinner
          fxLayoutAlign="center"
          mode="indeterminate"
          >
        </mat-progress-spinner>
      }
    </div>
    <mat-card-actions id="card">
      @if (!showProgressSpinner) {
        <button
          id="cancel-link"
          mat-raised-button
          fxFill
          color="primary"
          (click)="cancel()"
          >
          Back to Login
        </button>
      }
    </mat-card-actions>
  </mat-card-content>
</mat-card>
